module.exports = __webpack_public_path__ + "static/media/UN.e90328ce.jpeg";